import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    {
        key: 'ID_ROLE',
        label: 'id',
        type: 'number',
        defaultShow: true,
    },
    {
        key: 'ROLE_NAME',
        label: 'name',
        defaultShow: true,
    },
    {
        key: 'ROLE_INFO',
        label: 'info',
        defaultShow: true,
    },
    {
        key: 'countPermissions',
        label: 'countPermissions',
        type: 'number',
        defaultShow: true,
    },
];
